import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from '@core/communication/auth.interceptor';

/**
 * Http interceptor providers in outside-in order
 * If you provide interceptors A, then B, then C, requests will flow in A->B->C and responses will flow out C->B->A
 * */
export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
];
